import * as apiClient from "./apiClient";

export async function getLeadGroups() {
  const res = await apiClient.get("/api/contact-groups");
  return apiClient.unwrapData(res) || { items: [] };
}

export async function getLeadGroup(groupId) {
  const res = await apiClient.get(`/api/contact-groups/${groupId}`);
  return apiClient.unwrapData(res);
}

export async function createLeadGroup(payload) {
  const res = await apiClient.post("/api/contact-groups", { body: payload });
  return apiClient.unwrapData(res);
}

export async function parseLeadGroupUpload(formData) {
  const res = await apiClient.upload("/api/lead-groups/parse-upload", { formData });
  return apiClient.unwrapData(res);
}

export async function addLeadsToGroup(groupId, payload) {
  const res = await apiClient.post(`/api/contact-groups/${groupId}/contacts`, { body: payload });
  return apiClient.unwrapData(res);
}

export async function deleteLeadGroup(groupId) {
  const res = await apiClient.del(`/api/contact-groups/${groupId}`);
  return apiClient.unwrapData(res);
}
